// extracted by mini-css-extract-plugin
export var desktop = "nav-module--desktop--f15c9";
export var div = "nav-module--div--0dc2f";
export var mobile = "nav-module--mobile--667fc";